import { render, staticRenderFns } from "./unsupport.vue?vue&type=template&id=57d82845"
import script from "./unsupport.vue?vue&type=script&lang=js"
export * from "./unsupport.vue?vue&type=script&lang=js"
import style0 from "./unsupport.vue?vue&type=style&index=0&id=57d82845&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d82845')) {
      api.createRecord('57d82845', component.options)
    } else {
      api.reload('57d82845', component.options)
    }
    module.hot.accept("./unsupport.vue?vue&type=template&id=57d82845", function () {
      api.rerender('57d82845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploader/unsupport.vue"
export default component.exports